import React from 'react';
import queryString from 'query-string';
import { log } from '@emyw/core-lib';
const SocialLoginButtonExtension = _ref => {
  let {
    provider,
    scopes,
    onLoginSuccess,
    onLoginFailure,
    disabled,
    appId,
    ...props
  } = _ref;
  const style = {
    display: 'inline-block',
    margin: '5px',
    width: '100%'
  };
  const buildGoogleAuthURL = clientID => {
    let authURL = 'https://accounts.google.com/o/oauth2/auth';
    authURL += "?client_id=".concat(clientID);
    authURL += '&response_type=token';
    authURL += "&scope=".concat(encodeURIComponent(scopes));
    return authURL;
  };
  const buildFacebookAuthURL = clientID => {
    let authURL = 'https://www.facebook.com/dialog/oauth';
    authURL += "?client_id=".concat(clientID);
    authURL += '&response_type=token';
    authURL += '&access_type=online';
    // authURL += `&scope=${encodeURIComponent(scopes)}`;
    return authURL;
  };
  const triggerLogin = () => {
    let authURL = '';
    // These methods will prepare the authURL with the exception of the redirect_uri since that may change depending
    // on the environment (i.e. webpage, or chrome app)
    switch (provider) {
      case 'google':
        authURL = buildGoogleAuthURL(appId);
        break;
      case 'facebook':
        authURL = buildFacebookAuthURL(appId);
        break;
      default:
        break;
    }

    // if we are running in a chrome environment (i.e. chrome browser extension)
    // This assumes there is a background process listening for this action and performes the social auth there, returning the response
    if (chrome) {
      chrome.runtime.sendMessage({
        action: "".concat(provider, "-oauth2"),
        authURL
      }, response => {
        if ((response || '').lastError) {
          onLoginFailure(response.lastError);
        } else {
          const res = new URL(response.result.replace('#', '?').replace('??', '?'));
          log.trace(res.search);
          // log.trace(queryString.parse(res.search));
          const accessToken = queryString.parse(res.search).access_token;
          chrome.runtime.sendMessage({
            action: "".concat(provider, "-userInfo"),
            accessToken
          }, info => {
            const user = {
              provider,
              profile: info.profile,
              token: {
                accessToken
              }
            };
            onLoginSuccess(user);
          });
        }
      });
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      onClick: e => {
        if (!disabled) {
          triggerLogin(e);
        }
      },
      style: style
    }, props.children)
  );
};
SocialLoginButtonExtension.defaultProps = {
  disabled: false,
  provider: null,
  scopes: 'email',
  onLoginSuccess: undefined,
  onLoginFailure: undefined,
  appId: null
};
export default SocialLoginButtonExtension;